import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { EntityNotesPanel } from "@/components/app/entity-notes/entity-notes-panel";
import { orpc } from "@/lib/orpc";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/notes")({
  component: ResidentNotesTab,
});

function ResidentNotesTab() {
  const { residentId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  return (
    <EntityNotesPanel
      entityType="resident"
      entityId={residentId}
      facilityId={resident.facilityId}
      timezone={resident.facilityTimezone ?? "UTC"}
    />
  );
}
